<ng-container *ngIf="isBrowser">
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
</ng-container>
